import { Injectable, inject } from '@angular/core';
import { NativeService } from '@shared/services/native.service';

export interface AppleAuthResponse {
  email: string;
  userName: string;
  identityToken: string;
  userIdentifier: string;
  error: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AppleService {
  private readonly nativeService = inject(NativeService);

  async doLogin(): Promise<AppleAuthResponse> {
    const response = (await this.nativeService.communicationHandler.sendAndAwait(
      'appleLogin',
      {},
      null
    )) as AppleAuthResponse;
    if (response.error) {
      throw 'Unable to complete the native apple login';
    }
    return response;
  }
}
